import { useMemo } from "react";

export const usePosition = (position: string, S: { [key: string]: string }) => {
    const positionClass = useMemo(() => {
        switch (position) {
            case "POSITION_VIDEO_LEFT":
                return S.positionVideoLeft;
            case "POSITION_VIDEO_BOTTOM":
                return S.positionVideoBottom;
            default:
                return S.positionVideoRight;
        }
    }, [position, S]);

    return {
        positionClass,
    };
};
